import React from "react";
import PhaseReadingChart from "./PhaseReadingChart";
import { images } from "../../common/images";

const POWER_FACTOR_DECIMALS = { axis: 2, tooltip: 2 };

export default function PowerFactorLineChart({ selectedDeviceSelectedDayData }) {
  return (
    <PhaseReadingChart
      selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
      reading="pf"
      name="Power Factor"
      image={images.chartPowerFactor}
      iconBackgroundColor="rgba(34, 197, 94, 0.10)"
      axisTitle="Power factor"
      decimals={POWER_FACTOR_DECIMALS}
      min={0}
      max={1}
    />
  );
}
